<template>
  <div class="card detail-card">
    <div class="card-body">
      <div class="detail-grid">
        <div class="detail-section">
          <h6 class="section-title"><i class="fas fa-building mr-2"></i>会社情報</h6>
          <table class="table table-borderless detail-table">
            <tbody>
              <tr><th>会社名</th><td>{{ company.company_name }}</td></tr>
              <tr>
                <th>プラン</th>
                <td><span :class="company.plan === 'プレミアム' ? 'badge-premium' : 'badge-free'">{{ company.plan }}</span></td>
              </tr>
              <tr>
                <th>ステータス</th>
                <td><span :class="company.status === 1 ? 'badge-on' : 'badge-off'">{{ company.status === 1 ? '有効' : '無効' }}</span></td>
              </tr>
              <tr><th>法人番号</th><td>{{ company.corporate_number }}</td></tr>
              <tr><th>代表者名</th><td>{{ company.representative_name }}</td></tr>
              <tr><th>担当者名</th><td>{{ filteredCompanyDetails.staff_name }}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="detail-section">
          <h6 class="section-title"><i class="fas fa-store mr-2"></i>店舗・連絡先</h6>
          <table class="table table-borderless detail-table">
            <tbody>
              <tr><th>代表店舗</th><td>{{ filteredCompanyDetails.shop_name }}</td></tr>
              <tr>
                <th>所有店舗</th>
                <td>
                  <span v-for="(shop, i) in company.shops" :key="shop.id">
                    {{ shop.shop_name }}<span v-if="i < company.shops.length - 1">、</span>
                  </span>
                </td>
              </tr>
              <tr><th>郵便番号</th><td>{{ company.postal_code }}</td></tr>
              <tr><th>住所</th><td>{{ company.address }}</td></tr>
              <tr><th>電話番号</th><td>{{ company.phone_number }}</td></tr>
              <tr><th>URL</th><td>{{ company.url }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-footer detail-footer">
      <button class="btn btn-outline-secondary" @click="$router.push({name:'CompanyTopPage'})"><i class="fas fa-arrow-left mr-1"></i>TOPに戻る</button>
      <button class="btn btn-primary" @click="edit"><i class="fas fa-edit mr-1"></i>編集</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: {
        shops: [],
        staff: [],
      },
    }
  },
  computed: {
    filteredCompanyDetails() {
      if (!this.company) return {};
      const shop = this.company.shops.find(s => s.id === this.company.shop_id);
      const staff = this.company.staff.find(s => s.id === this.company.contact_person_id);
      return {
        shop_name: shop ? shop.shop_name : '-',
        staff_name: staff ? staff.name : '-',
      };
    },
  },
  mounted() {
    this.getCompanyDetails();
  },
  methods: {
    getCompanyDetails() {
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/company/' + this.$store.getters.company)
      .then(response => {
        this.company = response.data;
      })
      .catch(error => { console.log(error); });
    },
    edit() {
      this.$router.push({name:'CompanyEditPage2', params: {company_id: this.$store.getters.company}});
    },
  },
};
</script>

<style scoped>
.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}
@media (max-width: 768px) {
  .detail-grid { grid-template-columns: 1fr; }
}
.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #049C4C;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding-bottom: 10px;
  margin-bottom: 0;
  border-bottom: 2px solid #e2e8f0;
}
.detail-table th {
  width: 35%;
  font-weight: 600;
  font-size: 13px;
  color: #718096;
  padding: 10px 8px;
  border: none;
  white-space: nowrap;
}
.detail-table td {
  font-size: 15px;
  color: #1a202c;
  font-weight: 500;
  padding: 10px 8px;
  border: none;
}
.badge-on {
  display: inline-block;
  background: #c6f6d5;
  color: #22543d;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}
.badge-off {
  display: inline-block;
  background: #e2e8f0;
  color: #718096;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}
.badge-premium {
  display: inline-block;
  background: #fefcbf;
  color: #744210;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}
.badge-free {
  display: inline-block;
  background: #edf2f7;
  color: #4a5568;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
}
.detail-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
}
</style>
